
/* eslint-disable */
    import common from "@/util/common";
    import {useStore} from "@/store";
    import {defineComponent, reactive, ComputedRef, computed, toRefs} from "vue";

     interface State {
         content: string;
         icon: string;
         tit: string;
         showTxt: string;
         showStatus: Boolean;
     }
export default defineComponent({
    name: 'checkDescrip',
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    setup(props) {
        let state: State = reactive({
            content: '',
            icon: '',
            tit: '',
            showTxt: 'View More',
            showStatus: false,
        })
        const {renderData} = toRefs(props);
        function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            }
        state.icon = getData('conclusionIcon') || '';
        state.tit = getData('conclusionResult');
        state.content = getData('conclusionDesc');
        let store = useStore()
        return {
            state,
        }
    },
    methods: {
        changeShowStatus() {
            this.state.showStatus = !this.state.showStatus;
            this.state.showTxt = this.state.showStatus ? 'Show less' : 'View More';
        }
    }
})
